import Divider from '@material-ui/core/Divider/Divider';
import ExpansionPanel from '@material-ui/core/ExpansionPanel/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary/ExpansionPanelSummary';
import Grid from '@material-ui/core/Grid/Grid';
import { WithStyles } from 'decorators/withStyles';
import { IProductNew } from 'interfaces/product';
import ExpandMoreIcon from 'mdi-react/ExpandMoreIcon';
import React, { Component } from 'react';

import ChildItem from './ChildItem';
import storageService from 'services/storage';

interface IProps {
  key: number;
  classes?: any;
  product: IProductNew;
  isFirst?: boolean;
}

interface IState {
  personalizationOpen: boolean;
  expanded: boolean;
}

@WithStyles(() => ({
  container: {
    '@media screen and (min-width: 600px)': {
      paddingRight: '0 !important'
    }
  },
  img: {
    width: 50,
    height: 50,
    border: '1px solid #efefef',
    borderRadius: 50,
    objectFit: 'cover'
  },
  containerProduct: {
    display: 'flex',
    cursor: 'pointer',
    margin: '6px',
    backgroundColor: '#F3F3F3'
  },
  productImg: {
    minWidth: 125,
    minHeight: 'auto',
    backgroundSize: '100%',
    backgroundRepeat: 'no-repeat',
    display: 'flex',
    alignItems: 'flex-end'
  },
  themeProduct: {
    width: '50px,'
  },
  productName: {
    fontSize: '1rem',
    letterSpacing: '0.44px',
    fontFamily: 'Lato, sans-serif',
    color: '#8E8E8E',
    width: '100%',
    textAlign: 'left',
    wordBreak: 'break-word'
  },
  children: {
    fontSize: '1rem',
    fontWeight: 'bold',
    color: '#636871',
    width: '100%',
    textAlign: 'left'
  },
  containerInfos: {
    marginLeft: '12px'
  },
  infosTitle: {
    fontWeight: 'bold',
    fontSize: '0.75rem',
    margin: 0
  },
  themeName: {
    fontSize: '0.875rem',
    color: '#596375'
  },
  themeImg: {
    width: '80px',
    height: '40px',
    backgroundColor: '#ccc',
    '@media screen and (max-width: 960px)': {
      display: 'none'
    }
  },
  contentNamePrice: {
    marginTop: '12px'
  },
  contentInfos: {
    margin: '6px 0'
  },
  expasionPanelDetails: {
    padding: '8px'
  },
  expasionPanelSubTitle: {
    display: 'flex',
    flexDirection: 'row-reverse',
    alignItems: 'center',
    justifyContent: 'space-around',
    color: '#596375',
    fontWeight: 'bold',
    padding: '0 8px'
  },
  expansionPanelDivider: {
    width: 'calc(100% - 90px)',
    position: 'relative',
    top: '2px'
  },
  expansionPanelSummary: {
    padding: '0px 8px'
  },
  expansionPanel: {
    margin: '10px 0',
    border: '1px solid #ccc',
    borderRadius: '7px !important',
    boxShadow: '0px 0px #FFF',
    transition: '0.2s ease-in-out',
    '&:before': {
      backgroundColor: 'transparent'
    },
    '&:hover': {
      boxShadow: '1px 1px 5px 2px #ccc'
    }
  },
  imgOnMobile: {
    paddingRight: '1rem',
    justifyContent: 'center',
    display: 'flex',
    alignItems: 'center',
    '@media screen and (max-width: 900px)': {
      display: 'none'
    }
  },
  imgOnDesktop: {
    '@media screen and (max-width: 600px)': {
      display: 'none'
    }
  },

  childrenMessage: {
    textAlign: 'left',
    '@media screen and (max-width: 900px)': {
      textAlign: 'center'
    }
  },

  infoContainer: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    flexWrap: 'nowrap'
  }
}))
export default class TabWithChildren extends Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = { personalizationOpen: true, expanded: false };
  }

  componentDidMount() {
    const { isFirst } = this.props;
    storageService
      .get('personalization-open')
      .subscribe(personalizationOpen =>
        this.setState({ personalizationOpen, expanded: !personalizationOpen && isFirst })
      );
  }

  render() {
    const { classes, product, isFirst } = this.props;
    const { personalizationOpen, expanded } = this.state;
    const mountChild = product.children.length;
    const msgChildren = `Possui ${mountChild > 1 ? `${mountChild} variações` : `${mountChild} variação`}`;

    return (
      <ExpansionPanel
        onClick={() => this.setState({ expanded: !expanded })}
        expanded={expanded}
        classes={{ root: classes.expansionPanel }}
      >
        <ExpansionPanelSummary
          expandIcon={<ExpandMoreIcon size="35" />}
          classes={{ root: classes.expansionPanelSummary }}
        >
          <Grid item className={classes.imgOnMobile}>
            <img className={classes.img} src={product.image} />
          </Grid>
          <Grid xs={7} item container className={classes.infoContainer}>
            <Grid xs={8} item>
              <span className={classes.productName}>{`${product.id} - ${product.name}`}</span>
            </Grid>
            <Grid xs={3} item className={classes.childrenMessage}>
              <span className={classes.children}>{msgChildren}</span>
            </Grid>
          </Grid>
        </ExpansionPanelSummary>
        <div className={classes.expasionPanelSubTitle}>
          <Divider classes={{ root: classes.expansionPanelDivider }} />
          <span>Variações</span>
        </div>
        <ExpansionPanelDetails classes={{ root: classes.expasionPanelDetails }}>
          <Grid container>
            {product.children.map((children, index) => (
              <ChildItem
                child={children}
                key={index}
                isFirst={isFirst && index === 0}
                personalizationOpen={personalizationOpen}
              />
            ))}
          </Grid>
        </ExpansionPanelDetails>
      </ExpansionPanel>
    );
  }
}
